import { render, staticRenderFns } from "./CommitMessageModal.vue?vue&type=template&id=8e13d97a&"
import script from "./CommitMessageModal.vue?vue&type=script&lang=js&"
export * from "./CommitMessageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CommitMessageModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/CommitMessageModal.vue
// module id = 2326
// module chunks = 1